import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Transition as _Transition, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-696a4c94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "iapp" }
const _hoisted_2 = {
  class: "scroll-area channel-wrapper",
  ref: "chscroller"
}
const _hoisted_3 = {
  key: 0,
  class: "profile"
}
const _hoisted_4 = { class: "profile-wrap" }
const _hoisted_5 = { class: "profile-body" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "d-flex flex-row align-items-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_10 = { class: "profile-title" }
const _hoisted_11 = { class: "profile-meta flex-grow-0" }
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = { class: "d-flex flex-column flex-shrink-0" }
const _hoisted_14 = {
  key: 0,
  class: "mail-wr w-100"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  key: 1,
  class: "phone-wr w-100 mt-2"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "throbber-spacer" }
const _hoisted_22 = {
  key: 0,
  class: "throbber"
}
const _hoisted_23 = {
  class: "snippet",
  "data-title": ".dot-pulsing"
}
const _hoisted_24 = { class: "avatar-img" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stage" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot-pulse" })
], -1))
const _hoisted_26 = { class: "channel-area-wrapper" }
const _hoisted_27 = { class: "channel-area d-flex" }
const _hoisted_28 = { class: "chat-editor-frame" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadcrumbsBar = _resolveComponent("BreadcrumbsBar")!
  const _component_Mail = _resolveComponent("Mail")!
  const _component_Phone = _resolveComponent("Phone")!
  const _component_CellphoneMessage = _resolveComponent("CellphoneMessage")!
  const _component_VideoPane = _resolveComponent("VideoPane")!
  const _component_MessagingBubble = _resolveComponent("MessagingBubble")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_post = _resolveComponent("post")!
  const _directive_auth_image = _resolveDirective("auth-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BreadcrumbsBar, {
      back: "/messages",
      title: _ctx.state.user ? (_ctx.state.user.givenName + ' ' + _ctx.state.user.surName) : ''
    }, null, 8, ["title"]),
    _createVNode(_Transition, { name: "scroll-area" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.state.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          src: _ctx.imageUrl,
                          class: "avatar-img me-3"
                        }, null, 8, _hoisted_8),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.state.user.givenName) + " " + _toDisplayString(_ctx.state.user.surName), 1),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t('membersince')) + " " + _toDisplayString(_ctx.dateTime2(_ctx.state.user.createdAt)), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          (_ctx.state.user.contactEmail)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("a", {
                                  class: "me-2",
                                  href: 'mailto:'+_ctx.state.user.email
                                }, [
                                  _createVNode(_component_Mail, { class: "mail" })
                                ], 8, _hoisted_15),
                                _createElementVNode("a", {
                                  href: 'mailto:'+_ctx.state.user.email
                                }, _toDisplayString(_ctx.state.user.email), 9, _hoisted_16)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.state.user.contactPhone)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("a", {
                                  class: "btn btn-xs btn-outline-dark btn-rounded",
                                  href: 'tel:'+_ctx.state.user.phone
                                }, [
                                  _createVNode(_component_Phone, { class: "phone" })
                                ], 8, _hoisted_18),
                                _createElementVNode("a", {
                                  class: "ms-2 btn btn-xs btn-outline-dark btn-rounded",
                                  href: 'sms:'+_ctx.state.user.phone
                                }, [
                                  _createVNode(_component_CellphoneMessage, { class: "phone" }),
                                  _createTextVNode(" sms")
                                ], 8, _hoisted_19)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_VideoPane, {
            id: _ctx.state.id
          }, null, 8, ["id"]),
          _createVNode(_Transition, {
            name: "switch",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_ctx.state.messages && _ctx.state.messages.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createVNode(_TransitionGroup, {
                      tag: "ul",
                      name: "list",
                      appear: "",
                      id: "channel-messages",
                      class: "channel-messages scrollbox"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.messages, (msg) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: msg.id,
                            class: "message"
                          }, [
                            _createVNode(_component_MessagingBubble, { msg: msg }, null, 8, ["msg"])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_21, [
            (_ctx.state.throbber)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("img", _hoisted_24, null, 512), [
                      [_directive_auth_image, _ctx.throbberImage()]
                    ]),
                    _hoisted_25
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 512)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_QuillEditor, {
            class: "chat-editor",
            ref: "editor",
            content: _ctx.newMsg,
            options: _ctx.quillOptions,
            onTextChange: _ctx.textChange,
            "content-type": "html",
            theme: "snow"
          }, null, 8, ["content", "options", "onTextChange"]),
          _createElementVNode("button", {
            class: "send-btn btn",
            id: "send-btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.send1 && _ctx.send1(...args)))
          }, [
            _createVNode(_component_post)
          ])
        ])
      ])
    ])
  ]))
}